<template>
    <div @mouseleave="activeSubmenu = null">
        <div class="main-items">
            <div v-for="item in menuConfig.mainMenu" :key="item.id">
                <a :href="item.url">
                    <menu-item
                        :isActive="item.id === menuConfig.activeConfig.activeParentId"
                        @mouseover="activeSubmenu = item.submenu"
                    >
                        {{ item.__title }}
                    </menu-item>
                </a>
                <sub-menu
                    v-if="isnavopen && item.id === menuConfig.activeConfig.activeParentId"
                    :activeConfig="menuConfig.activeConfig"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import SubMenu from "./SubMenu.vue";
import MenuItem from "./MenuItem.vue";

export default Vue.extend({
    props: ["isnavopen", "menuConfig", "userInitialName"],
    components: {
        SubMenu,
        MenuItem,
    },
    data() {
        return {
            activeSubmenu: null,
        };
    },
});
</script>

<style lang="sass" scoped>
.main-items
    display: flex
    justify-content: stretch
    flex-wrap: wrap
    width: 100%
    +r(1140)
        flex-direction: column

    a
        display: inline-block
        text-decoration: none
        +r(1140)
            width: 100%
            box-shadow: 0px 3px 6px rgba(0,0,0,0.16)
        &:hover
            .menu-item
                &:after
                    background: $color-main
                    +r(1140)
                        background: none
</style>
